import React from 'react';
import { HStack, Text } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Chip from 'components/_core/Chip';
import SunshineIcon, { IconName } from 'components/_core/SunshineIcon';

import { DashboardFilter } from '../../../types';

export const FilterPill: FCWithChildren<
  {
    icon?: IconName;
  } & React.ComponentProps<typeof Chip>
> = ({ children, icon, ...chipProps }) => {
  return (
    <Chip {...chipProps}>
      <HStack spacing="space-8">
        {icon ? <SunshineIcon name={icon} size="icon-20" /> : null}
        <Text>{children}</Text>
      </HStack>
    </Chip>
  );
};

type FilterGroupType = FCWithChildren<
  React.ComponentProps<typeof HStack> & {
    filters: {
      icon?: IconName;
      id: DashboardFilter;
      label: string;
    }[];
    activeFilterId: DashboardFilter | null;
    onFilterClicked: (id: DashboardFilter) => void;
  }
>;

export const FilterGroup: FilterGroupType = ({
  activeFilterId,
  filters = [],
  onFilterClicked,
  ...hsTackProps
}) => {
  return (
    <HStack spacing="space-16" {...hsTackProps}>
      {filters.map(({ icon, id, label }) => {
        return (
          <FilterPill
            icon={icon}
            isActive={activeFilterId === id}
            key={id}
            onClick={() => onFilterClicked(id)}
          >
            {label}
          </FilterPill>
        );
      })}
    </HStack>
  );
};
